export const getUniqueProductFamilies = ({ productFamilies = [] }) =>
  productFamilies.reduce((families, current) => {
    const familiesCodes = families.find((f) => f?.familyGroupName === current?.familyGroupName || f?.familyGroup === current?.familyGroup);
    return !familiesCodes ? [...families, current] : families;
  }, []);
